<template>
    <el-form-item prop="scheduledGates" class="py-1">
        <div class="text-left">

            <span class="text-white body-2">{{schedule.Description}}</span>
            <span class="text-white body-2" style="margin-left: 5px;color:#34c8b4;">({{getContainerName()}})</span>
        </div>
        <v-select
            :items="gates"
            :label="$t('form.label.selectGate')"
            v-model="enabledGates"
            item-value="Name"
            item-text="Name"
            return-object
            clearable
            multiple
            required
            chips
            dark
        >
        </v-select>
    </el-form-item>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    name: 'scheduled-gate-access',

    props: ['gates', 'schedule', 'scheduledGates'],

    data() {
        return {
            enabledGates: this.scheduledGates || [],
        }
    },

    watch: {
        enabledGates() {
            this.$emit('gates-scheduled', {
                schedule: this.schedule,
                gates: this.enabledGates,
            })
        },
    },
    computed: {
        ...mapGetters([
            'containers'
        ]),
    },
    methods:{
        getContainerName(){
            const container = _.find(this.containers, {
                ContainerID: this.schedule.ContainerId
            })
            return container.Description
        }
    }
}
</script>
